<template>
  <v-dialog v-model="dialog" max-width="750" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on"
        ><v-icon>mdi-cart-outline</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-card-title class="green lighten-4 font-weight-bold primary--text"
        >Produtos</v-card-title
      >
      <v-card-text>
        <v-progress-linear
          class="mt-5"
          indeterminate
          v-if="!nota || carregando"
        ></v-progress-linear>
        <v-data-table
          v-else
          :items="nota.produtos"
          :headers="headers"
          class="mt-5"
          dense
          :search="filtro"
          :loading="carregando"
          loading-text="Carregando produtos"
          no-data-text="Nenhum produto encontrado"
          no-results-text="Nenhum produto localizado"
        >
          <template v-slot:top>
            <v-row>
              <v-col xl="4" lg="4" md="4" sm="12" cols="12" align-self="center">
                <v-card flat color="grey lighten-4">
                  <v-card-title class="subtitle-2 pt-3"
                    >Meu gasto nesta nf</v-card-title
                  >
                  <v-card-subtitle
                    class="font-weight-bold subtitle-1 info--text pb-2"
                    >{{ formatarMoeda(nota.valor_consumido) }}</v-card-subtitle
                  >
                </v-card>
              </v-col>
              <v-col xl="8" lg="8" md="8" sm="12" cols="12">
                <v-text-field
                  v-model="filtro"
                  label="Pesquisar produto"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.vlr_unitario`]="{ item }">
            {{ formatarMoeda(item.vlr_unitario) }}
          </template>
          <template v-slot:[`item.vlr_total`]="{ item }">
            {{ formatarMoeda(item.vlr_total) }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="secondary" @click="dialog = false" rounded
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { formatMoeda } from "@/global";

export default {
  props: {
    compra: Number,
  },
  watch: {
    dialog: async function (open) {
      if (open) {
        await this.getCompra();
      }
    },
  },
  data: () => ({
    dialog: false,
    filtro: "",
    nota: null,
    carregando: false,
    headers: [
      { text: "Nota", value: "nota_fiscal" },
      { text: "Produto", value: "produto" },
      { text: "Qtde", value: "qtde" },
      { text: "Emb", value: "embalagem" },
      { text: "Valor Unit", value: "vlr_unitario" },
      { text: "Valor Total", value: "vlr_total" },
    ],
  }),
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    async getCompra() {
      this.carregando = true;
      this.nota = null;
      await axios
        .get(`/colaborador/financeiro?funcao=COMPRAS&compra=${this.compra}`)
        .then((res) => {
          if (res.data.success) {
            this.nota = res.data.data;
          }
        })
        .catch((e) => this.$toasted.error(e));
      this.carregando = false;
    },
  },
};
</script>

<style>
</style>